import CookieRequestInterceptor from "./CookieRequestInterceptor";

type CookieAuthProviderProps = {
  children: React.ReactNode;
};

const CookieAuthProvider = ({ children }: CookieAuthProviderProps) => {
  return <CookieRequestInterceptor>{children}</CookieRequestInterceptor>;
};

export default CookieAuthProvider;
